var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from "hanako-ts/dist-legacy/Component";
export class Page extends Component {
    constructor() {
        super('Page', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('resize', () => {
                this.adjustBodyPaddingTop();
            });
            this.adjustBodyPaddingTop();
            this.success();
        });
    }
    adjustBodyPaddingTop() {
        if ($(window).width() < 768) {
            let paddingTop = 80 + $('#left-menu').height();
            //$('body').css('padding-top', paddingTop + 'px', 'important');
        }
        else {
            $('body').css('padding-top', '', 'important');
        }
    }
}
